import Option from "@p-ban/common/src/components/form/SelectBox/Option"
import Select from "@p-ban/common/src/components/form/SelectBox/Select"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"

import img from "./manuOptPlanCad.png"

const 設計CAD = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { manuOptPlanCad: shouldShow } = getDisplayCondition(values)

  const legend = "設計CAD"

  return (
    <OneClickField isShow={shouldShow} legend={legend} src={img}>
      <OneClickFieldStack>
        <Select name={FIELD_NAMES.設計CAD} value={values.manuOptPlanCad} onChange={handlers.select} aria-label={legend}>
          {Object.values(ESTIMATE_CONSTANT.設計CAD).map(({ name, value }) => (
            <Option key={value} value={value}>
              {name}
            </Option>
          ))}
        </Select>
      </OneClickFieldStack>
      <OneClickFieldMessages error={errors?.manuOptPlanCad} />
    </OneClickField>
  )
}

export default 設計CAD
